import { generateTestId } from "@client-shared/lib/util";
export const setAuthCallbackTestId = (label: string) =>
  generateTestId("AuthCallback", label.replace(/\s/g, "-").toLowerCase());
